export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=875333d0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/AdminChiefs/index.vue?vue&type=template&id=875333d0&scoped=true
// module id = 2562
// module chunks = 31